import * as React from 'react';

/* ============================================================================
   SvgIconStyle - icone monocromatico a partir de um .svg externo.

   Continua fazendo a mesma coisa de sempre: um <span> vazio com o SVG aplicado
   como MASCARA e `background: currentColor`. E o que permite os icones do menu
   herdarem a cor do item (ativo/inativo) sem ter uma cor gravada em cada arquivo.

   Sem MUI: era um `<Box component="span" sx={{...}}>`, que arrastava o tema todo
   por causa de um span. As duas unicas telas que passam `sx` mandam
   `{ width: 1, height: 1 }` - a notacao do MUI para 100% -, entao esse caso e
   traduzido explicitamente e o resto vira CSS direto. `sx` segue aceito para nao
   quebrar chamador nenhum.
   ============================================================================ */

export interface SvgIconStyleType {
  src: string;
  /** Compatibilidade com os chamadores antigos. `1` = 100%, numero = px. */
  sx?: Record<string, any>;
  className?: string;
}

function medida(valor: any, padrao: string) {
  if (valor === undefined || valor === null) return padrao;
  if (valor === 1) return '100%';
  return typeof valor === 'number' ? `${valor}px` : String(valor);
}

export const SvgIconStyle: React.FunctionComponent<SvgIconStyleType> = ({ src, sx, className }) => (
  <span
    aria-hidden
    className={className}
    style={{
      display: 'inline-block',
      width: medida(sx?.width, '24px'),
      height: medida(sx?.height, '24px'),
      backgroundColor: 'currentColor',
      mask: `url(${src}) no-repeat center / contain`,
      WebkitMask: `url(${src}) no-repeat center / contain`,
    }}
  />
);

export default SvgIconStyle;
